import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import useAuth from "hooks/useAuth"
import { AppGuestRoutes } from "@/config/routes"

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const { loggedUser } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (!loggedUser) {
            navigate(AppGuestRoutes.login.getLink(), {
                state: {
                    from: `${location.pathname}${location.search}`,
                },
                replace: true,
            })
        }
    }, [loggedUser, navigate, location])

    return children
}

export default AuthGuard
